import { getRandomInt, getRandomIntMultipleOf } from '~/bootcamp/Activities/Fractions/Fractions.utils'

interface RangeModel {
  numerator: { min: number; max: number }
  denominator: { min: number; max: number }
  divisor: { min: number; max: number }
  variation: number
}

interface DifficultyLevelRangeMapModel {
  [key: number]: RangeModel
}

const DIFFICULTY_LEVEL_RANGE_MAP: DifficultyLevelRangeMapModel = {
  1: { numerator: { min: 2, max: 8 }, denominator: { min: 4, max: 10 }, divisor: { min: 2, max: 2 }, variation: 16 },
  2: { numerator: { min: 0, max: 20 }, denominator: { min: 10, max: 20 }, divisor: { min: 5, max: 5 }, variation: 15 },
  3: { numerator: { min: 0, max: 30 }, denominator: { min: 6, max: 30 }, divisor: { min: 3, max: 3 }, variation: 30 },
  4: {
    numerator: { min: 0, max: 100 },
    denominator: { min: 6, max: 100 },
    divisor: { min: 6, max: 10 },
    variation: 40,
  },
}

export interface FractionSimplifyDenomQuestionModel {
  leftNum: number
  leftDenom: number
  divisor: number
  rightDenom: number
  maxVariation: number
}

export function getFractionSimplifyDenomQuestion(
  difficultyLevel: number,
  excludes?: string[],
): FractionSimplifyDenomQuestionModel {
  const range = DIFFICULTY_LEVEL_RANGE_MAP[difficultyLevel]

  const divisor = getRandomInt(range.divisor.min, range.divisor.max)
  const leftDenom = getRandomIntMultipleOf(range.denominator.min, range.denominator.max, divisor)
  const leftNum = getRandomIntMultipleOf(range.numerator.min, leftDenom - 1, divisor)
  const rightDenom = leftDenom / divisor

  const key = `${divisor}-${leftNum}-${leftDenom}`
  if (excludes && excludes.includes(key)) return getFractionSimplifyDenomQuestion(difficultyLevel, excludes)

  return { leftNum, leftDenom, rightDenom, divisor, maxVariation: range.variation }
}
